import React, { useRef, useEffect } from 'react'
import ValidityWarning from '../ValidityWarning'
import { Trans } from 'gatsby-plugin-react-i18next'

const PossibleInderteminateCheckbox = ({
    checkbox,
    handleChange,
    checkStatus,
}) => {
    const checkBoxRef = useRef(null)

    useEffect(() => {
        if (checkStatus === 'some') {
            checkBoxRef.current.indeterminate = true
        } else {
            checkBoxRef.current.indeterminate = false
        }
    }, [checkBoxRef, checkStatus])

    return (
        <div className="form-control">
            <label className="label cursor-pointer">
                <input
                    type="checkbox"
                    name={checkbox.name}
                    onClick={(evt) =>
                        handleChange(evt, checkbox.children, checkStatus)
                    }
                    checked={
                        checkStatus !== 'none' && checkStatus !== 'some'
                            ? true
                            : false
                    }
                    ref={checkBoxRef}
                    className="checkbox z-[9999]"
                />
                <span className="label-text text-wrap ml-2 font-bold text-lg capitalize">
                    <Trans>{checkbox.label}</Trans>
                </span>
            </label>
        </div>
    )
}

class CheckboxGroup extends React.Component {
    constructor(props) {
        super(props)
        const checked = {}
        const secondaryChecked = {}

        if (typeof props.initialChecked === 'object') {
            props.initialChecked?.forEach((spec) => {
                checked[spec] = true
            })
        }
        if (typeof props.secondaryInitialChecked === 'object') {
            props.secondaryInitialChecked?.forEach((sChecked) => {
                secondaryChecked[sChecked] = true
            })
        }
        this.state = {
            checked,
            secondaryChecked,
            valid: props.valid,
        }
    }

    getDerivedStateFromProps(nextProps, prevState) {
        const checked = {}
        const secondaryChecked = {}
        if (typeof nextProps.initialChecked === 'object') {
            nextProps.initialChecked?.forEach((spec) => {
                checked[spec] = true
            })
        }
        if (typeof nextProps.secondaryInitialChecked === 'object') {
            nextProps.secondaryInitialChecked?.forEach((sChecked) => {
                secondaryChecked[sChecked] = true
            })
        }
        return {
            checked,
            secondaryChecked,
            valid: nextProps.valid,
        }
    }

    checkedArr = (checkedObj, name) =>
        Object.keys(checkedObj).filter((key) => {
            return checkedObj[key] === true
        })

    onChange = (evt) => {
        const { name } = evt.target
        const checked = {
            ...this.state.checked,
            [name]: !this.state.checked[name],
        }
        const checkedArr = this.checkedArr(checked, name)

        this.props.updateState(this.props.name, checkedArr)
        this.setState({
            checked,
            valid: checkedArr.length > 0,
        })
    }

    handleParentCheckBox = (evt, children, status) => {
        evt.stopPropagation()
        const { name } = evt.target
        const statusToApply =
            status === 'all' || status === 'some' ? false : true
        const newChecks = {}
        for (let i = 0; i < children.length; i++) {
            if (
                this.props.lawyerOrNotary !== 'immigrationConsultant' ||
                !statusToApply
            ) {
                newChecks[children[i].name] = statusToApply
            } else if (
                this.props.lawyerOrNotary !== 'immigrationConsultant' &&
                children[i].immigrationConsultant
            ) {
                newChecks[children[i].name] = statusToApply
            }
            if (this.props.lawyerOrNotary === 'lawyer') {
                newChecks[children[i].name] = statusToApply
            }
        }
        const checked = {
            ...this.state.checked,
            ...newChecks,
        }

        const checkedArr = this.checkedArr(checked, name)
        this.props.updateState(this.props.name, checkedArr)
        this.setState({
            checked,
            valid: checkedArr.length > 0,
        })
    }

    onSecondaryChange = (evt) => {
        evt.stopPropagation()
        const { name } = evt.target
        const secondaryChecked = {
            ...this.state.secondaryChecked,
            [name]: !this.state.secondaryChecked[name],
        }
        const checkedArr = this.checkedArr(secondaryChecked, name)
        this.props.updateState(this.props.secondaryName, checkedArr)
        this.setState({ secondaryChecked })
    }

    parentCheckStatus = (children) => {
        let numChecked = 0
        let possibleChecked = 0
        for (let i = 0; i < children.length; i++) {
            if (this.state.checked[children[i].name] && !children[i].disabled) {
                numChecked++
            }
            if (!children[i].disabled) {
                if (this.props.lawyerOrNotary === 'immigrationConsultant') {
                    if (children[i].immigrationConsultant) {
                        possibleChecked++
                    }
                } else {
                    possibleChecked++
                }
            }
        }
        if (numChecked === 0) {
            return 'none'
        }
        return numChecked === possibleChecked ? 'all' : 'some'
    }

    renderCheckBoxes = (checkboxes, lawyerOrNotary) => {
        return checkboxes.map((checkbox) => {
            if (checkbox.disabled) {
                return null
            }

            if (checkbox.name === 'other' || checkbox.name === 'on-other') {
                return null
            }

            if (checkbox.children && !this.props.onlyParents) {
                if (lawyerOrNotary === 'immigrationConsultant') {
                    let immigrationAvailable = false
                    checkbox.children?.forEach((c) => {
                        if (c.immigrationConsultant) {
                            immigrationAvailable = true
                        }
                    })
                    if (!immigrationAvailable) {
                        return null
                    }
                }
                const checkStatus = this.parentCheckStatus(checkbox.children)
                return (
                    <div
                        key={checkbox.name}
                        className="collapse collapse-arrow bg-base-200 mb-2">
                        <input type="checkbox" />
                        <div className="collapse-title flex items-center gap-4 flex-wrap">
                            <div
                                className="relative z-[2]"
                                onClick={(evt) => evt.stopPropagation()}>
                                <PossibleInderteminateCheckbox
                                    checkbox={checkbox}
                                    checkStatus={checkStatus}
                                    handleChange={this.handleParentCheckBox}
                                />
                            </div>

                            {checkbox.certRequired &&
                            !this.props.hideCerts &&
                            (checkStatus === 'some' ||
                                checkStatus !== 'none') ? (
                                <div
                                    className="relative z-[2]"
                                    onClick={(evt) => evt.stopPropagation()}>
                                    <div className="form-control">
                                        <label className="label cursor-pointer">
                                            <input
                                                name={checkbox.name}
                                                type="checkbox"
                                                checked={
                                                    this.state.secondaryChecked[
                                                        checkbox.name
                                                    ]
                                                        ? true
                                                        : false
                                                }
                                                onChange={
                                                    this.onSecondaryChange
                                                }
                                                className="checkbox z-[9999]"
                                            />
                                            <span className="label-text text-wrap ml-2 text-sm">
                                                <Trans i18nKey="legalAidCert">
                                                    Je suis sur le panel d’aide
                                                    juridique
                                                </Trans>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="collapse-content">
                            <div className="pt-2 grid grid-cols-1 md:grid-cols-3">
                                {this.renderCheckBoxes(
                                    checkbox.children,
                                    lawyerOrNotary,
                                )}
                            </div>
                        </div>
                    </div>
                )
            } else {
                if (
                    this.props.lawyerOrNotary === 'immigrationConsultant' &&
                    !checkbox.immigrationConsultant
                ) {
                    return null
                }
                if (checkbox.topLevel && !this.props.onlyParents) {
                    return (
                        <div
                            key={checkbox.name}
                            className="bg-base-200 p-4 rounded-lg mb-2 flex flex-wrap items-center gap-4">
                            <div className="form-control">
                                <label className="label cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name={checkbox.name}
                                        onChange={this.onChange}
                                        checked={
                                            this.state.checked[checkbox.name] ||
                                            false
                                        }
                                        className="checkbox"
                                    />
                                    <span className="label-text text-wrap ml-2 font-bold text-lg capitalize">
                                        <Trans>{checkbox.label}</Trans>
                                    </span>
                                </label>
                            </div>
                            {checkbox.certRequired && !this.props.hideCerts ? (
                                <div className="form-control">
                                    <label className="label cursor-pointer">
                                        <input
                                            name={checkbox.name}
                                            type="checkbox"
                                            checked={
                                                this.state.secondaryChecked[
                                                    checkbox.name
                                                ]
                                                    ? true
                                                    : false
                                            }
                                            onChange={this.onSecondaryChange}
                                            className="checkbox z-[9999]"
                                        />
                                        <span className="label-text text-wrap ml-2 text-sm">
                                            <Trans i18nKey="legalAidCert">
                                                Je suis sur le panel d’aide
                                                juridique
                                            </Trans>
                                        </span>
                                    </label>
                                </div>
                            ) : null}
                        </div>
                    )
                }
                return (
                    <div key={checkbox.name}>
                        <div className="form-control">
                            <label className="label cursor-pointer justify-start py-1">
                                <input
                                    type="checkbox"
                                    name={checkbox.name}
                                    onChange={this.onChange}
                                    checked={
                                        this.state.checked[checkbox.name] ||
                                        false
                                    }
                                    className="checkbox"
                                />
                                <span className="label-text text-wrap ml-2 capitalize">
                                    <Trans>{checkbox.label}</Trans>
                                </span>
                            </label>
                        </div>
                        {checkbox.certRequired &&
                        this.props.hideCerts &&
                        this.state.checked[checkbox.name] ? (
                            <div className="form-control ml-6">
                                <label className="label cursor-pointer justify-start py-1">
                                    <input
                                        name={checkbox.name}
                                        type="checkbox"
                                        checked={
                                            this.state.secondaryChecked[
                                                checkbox.name
                                            ]
                                                ? true
                                                : false
                                        }
                                        onChange={this.onSecondaryChange}
                                        className="checkbox z-[9999]"
                                    />
                                    <span className="label-text text-wrap ml-2 text-sm">
                                        <Trans i18nKey="legalAidCert">
                                            Je suis sur le panel d’aide
                                            juridique
                                        </Trans>
                                    </span>
                                </label>
                            </div>
                        ) : null}
                    </div>
                )
            }
        })
    }

    render() {
        return (
            <>
                {!this.state.valid && (
                    <ValidityWarning
                        validityMessage={<Trans>{this.props.helperText}</Trans>}
                    />
                )}

                {this.renderCheckBoxes(
                    this.props.checkboxes,
                    this.props.lawyerOrNotary,
                )}
            </>
        )
    }
}

export default CheckboxGroup
